import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { showConfirmation } from '../../../ConfirmationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { icon } from '@fortawesome/fontawesome-svg-core';

import pay_my_bill from '../../../images/ClientStatic/pay_my_bill.png';
import payment_options from '../../../images/ClientStatic/payment_options.png';
import report_a_problem from '../../../images/ClientStatic/report_a_problem.png';
import start_stop_service from '../../../images/ClientStatic/start_stop_service.png';
import { showNotification } from '../../../StatusNotification';

export class IconLinkForm extends Component {
    static displayName = IconLinkForm.name;

    constructor(props) {
        super(props);
        this.state = {
            iconLink: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus,
            iconLinkContainerId: this.props.iconLinkContainerId,
            isEditOnly: this.props.isEditOnly != undefined ? this.props.isEditOnly : false,
            isInPopup: this.props.isInPopup != undefined ? this.props.isInPopup : false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newIconLink = this.state.iconLink;
        newIconLink[e.target.name] = e.target.value;
        this.setState({ iconLink: newIconLink });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let iconLink = this.state.iconLink;
        iconLink.versionId = this.state.versionId;
        iconLink.pageId = this.state.pageId;
        iconLink.iconLinkContainerId = this.state.iconLinkContainerId;

        let url = this.state.formType == "Update" ? "UpdateIconLink" : "CreateIconLink";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(iconLink),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    if (!this.state.isEditOnly) {
                        //var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                        //var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "IconLink", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        if (this.state.isInPopup) {
            deleteButton = null;
        }

        let icon;
        let link;
        let componentName;
        if (this.state.iconLink != null) {
            let iconLink = this.state.iconLink;

            icon = iconLink.icon;
            link = iconLink.link;
            componentName = iconLink.componentName;
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <form id='iconLinkForm' onSubmit={this.handleSubmit.bind(this)} className={wrapperClasses}>
                <div className='tri-grid'>
                    <div className='tri-grid__1-3 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('IconLink')}</h2>
                    </div>

                    <label htmlFor='iconLink-componentName'>Component Name:</label>
                    <input id='iconLink-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />
                    <div></div>

                    <label>Icon: </label>
                    <div>
                        <div className='inner-quad-grid'>
                            <div>
                                <input type='radio' id='paymentOptions' name='icon' value='payment_options' checked={icon == 'payment_options'} onChange={this.handleChange} required />
                                <label htmlFor='paymentOptions'><img src={payment_options} alt="Payment options icon" /></label>
                            </div>

                            <div>
                                <input type='radio' id='payMyBill' name='icon' value='pay_my_bill' checked={icon == 'pay_my_bill'} onChange={this.handleChange} required />
                                <label htmlFor='payMyBill'><img src={pay_my_bill} alt="Pay my bill icon" /></label>
                            </div>

                            <div>
                                <input type='radio' id='reportAProblem' name='icon' value='report_a_problem' checked={icon == 'report_a_problem'} onChange={this.handleChange} required />
                                <label htmlFor='reportAProblem'><img src={report_a_problem} alt="Report a problem icon" /></label>
                            </div>

                            <div>
                                <input type='radio' id='startStopService' name='icon' value='start_stop_service' checked={icon == 'start_stop_service'} onChange={this.handleChange} required />
                                <label htmlFor='startStopService'><img src={start_stop_service} alt="Start/Stop Service icon" /></label>
                            </div>
                        </div>
                    </div>
                    <div></div>

                    <label htmlFor='iconLink-link'>Link: </label>
                    <input id='iconLink-link' name='link' type='text' defaultValue={link} onChange={this.handleChange} required />
                    <div></div>

                    <div className='tri-grid__1-3'>
                        <button form='iconLinkForm' type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetIconLink?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            iconLink: data,
            formType: formType
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteIconLink?componentId=' + this.state.iconLink.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default IconLinkForm;